import { roundNearest } from "@kateinnovations/javascript-helpers";

const getAllApplicationModules = ({ applicationLoader }) => applicationLoader.entities;
const getTotalApplicationWeight = ({ applicationLoader }) => {
    const total = applicationLoader.entities.reduce((value, item) => {
        const newValue = value + item.weight;

        return newValue;
    }, 0);

    return total;
};
const getTotalApplicationWeightIsLoaded = ({ applicationLoader }) => {
    const total = applicationLoader.entities.reduce((value, item) => {
        if (item.isLoaded) {
            const newValue = value + item.weight;

            return newValue;
        }

        return value;
    }, 0);

    return total;
};

const getPercentageLoaded = ({ applicationLoader }) => {
    const totalWeightIsLoaded = getTotalApplicationWeightIsLoaded({ applicationLoader });
    const totalWeight = getTotalApplicationWeight({ applicationLoader });

    const percentage = (totalWeightIsLoaded / totalWeight) * 100;

    return roundNearest(percentage) || 0;
};

const getAllApplicationIsLoaded = ({ applicationLoader }) => applicationLoader.isLoaded;

const getTranslationsIsLoaded = ({ applicationLoader }) => {
    const translations = applicationLoader.entities.find((item) => item.title === "translations");

    return translations.isLoaded;
};

export {
    getAllApplicationModules,
    getTotalApplicationWeight,
    getTotalApplicationWeightIsLoaded,
    getAllApplicationIsLoaded,
    getPercentageLoaded,
    getTranslationsIsLoaded,
};
